import { IndicationItem } from 'features/indicationTriage'
import { GeckoComponentModel } from 'types'

import { FfsPart } from './ffsTypes'

export interface ComputeFfsEligibilityArgs {
  /** Typed asset-model component model (source of geometry + type). */
  componentModel: GeckoComponentModel | undefined
  /** The FFS part the eligibility is being computed for. */
  part: FfsPart
  /**
   * The LTA indication under assessment. Unused today, but part of the
   * signature so a future per-LTA eligibility rule can land without breaking
   * callers. Typed as the base `IndicationItem` so both `RolodexIndication`
   * (from the step's indication set) and the detail card's `useIndicationData()`
   * indication are accepted. See the FFS pre-planning step.
   */
  indication?: IndicationItem
}

export interface FfsEligibility {
  level1Eligible: boolean
  level2Eligible: boolean
  /** Human-readable reasons a level is disabled, surfaced as tab tooltips. */
  reasons?: {
    level1?: string
    level2?: string
  }
}

/**
 * Deterministic eligibility for an FFS part's levels, keyed on the component.
 *
 * This is a SEAM: today every level is eligible. The future FFS pre-planning
 * step will replace the body with the real API 579 branching rules (which part
 * / level applies given the component type and its data), driving the level
 * locking in `FfsCalcCard`. Eligibility is intentionally COMPUTED here, not
 * stored on the ticket -- it is a deterministic function of the component.
 */
export function computeFfsEligibility(
  // Seam: the future FFS pre-planning step will derive eligibility from these
  // args (component / part / indication). Unused until then.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  args: ComputeFfsEligibilityArgs
): FfsEligibility {
  return { level1Eligible: true, level2Eligible: true }
}
